import Vue from 'vue'
import Router from 'vue-router'

import pageHeader from '../components/headerMenuLogin/pageHeader.vue' //页头
import pageLogin from '../components/headerMenuLogin/pageLogin.vue' //登录
import pageLogon from '../components/headerMenuLogin/pageLogon.vue' //注册
import pageMenu from '../components/headerMenuLogin/pageMenu.vue' //菜单
import comprehensivePage from '../comprehensivePage.vue' //综合页面



//店铺管理
import storeManagement from '../components/storeManagementList/storeManagement' //店铺管理
import shopDetails from '../components/storeManagementList/shopDetails' //店铺详情
//订单管理
import order from '../components/storeManagementList/order'
//
import homePageImg from '../components/homePageImg'
import password from '../components/password' //密码管理
import home from '../components/home'
import MonthOrder from '../components/MonthOrder' //按月份查询订单
import SetMeal from '../components/SetMeal' //新增套餐
import couponPackage from '../components/couponPackage' //优惠券包列表
import shopManage from '../components/shopManage' //店铺管理
import shopAdd from '../components/shopAdd' //店铺添加
import staffList from '../components/staffList' //店铺添加
import couponSetting from '../components/couponSetting' //券设置
import couponList from '../components/couponList' //优惠券列表
import SetMealList from '../components/SetMealList' //景区列表
import scenicList from '../components/scenicList' //景区列表
import coupons from '../components/coupons' //券包详情
import statistics from '../components/statistics' //券统计
import coupon from '../components/coupon' //券详情
import EditList from '../components/EditList' //修改要添加的列表
import AccountList from '../components/AccountList' //账号管理
import OrderDetails from '../components/OrderDetails' //景区订单详情
import PackageOrders from '../components/PackageOrders.vue' //景区套餐详情
import ActivityList from '../components/activityList.vue' //景区套餐详情
import MemberList from '../components/memberList.vue'
/* 明信片 */
import cardOrder from '../components/card/order.vue';
import cardList from '../components/card/list.vue';
import postcard from '../components/card/postcard.vue';
import sms from '../components/card/sms.vue';
import protocol from '../components/card/protocol.vue';


Vue.use(Router)

export default new Router({
    routes: [
        //综合页面
        {
            path: '/comprehensivePage',
            component: comprehensivePage,
            meta: {
                requiresAuth: true
            },

            children: [
                //店铺管理
                { //店铺管理
                    path: '/storeManagement',
                    component: storeManagement,
                    name: 'storeManagement',
                },
                { //店铺详情
                    path: '/shopDetails',
                    component: shopDetails,
                    meta: {
                        requiresAuth: true
                    },
                },
                { //
                    path: '/homePageImg',
                    component: homePageImg,
                    meta: {
                        requiresAuth: true
                    },
                },
                //密码管理
                {
                    path: '/password',
                    component: password,
                },
                // 账号管理
                {
                    path: '/AccountList',
                    component: AccountList,
                    meta: {
                        requiresAuth: true
                    },
                },
                //订单管理
                {
                    path: '/order',
                    component: order,
                    name: 'order',
                },
                //首页
                {
                    path: '/home',
                    component: home,
                    name: 'home',
                },
                //按月份查看订单
                {
                    path: '/MonthOrder',
                    component: MonthOrder,
                    name: 'MonthOrder',
                },
                //新增套餐
                {
                    path: '/SetMeal',
                    component: SetMeal,
                    name: 'SetMeal',
                },
                //套餐列表
                {
                    path: '/SetMealList',
                    component: SetMealList,
                    name: 'SetMealList',
                },
                {//景区列表
                    path: '/scenicList',
                    component: scenicList,
                    name: 'scenicList',
                },
                {//券包管理
                    path: '/couponPackage',
                    component: couponPackage,
                    name: 'couponPackage',
                },
                {path: '/cardOrder', component: cardOrder, name: 'cardOrder'},//明信片订单
                {path: '/cardList', component: cardList, name: 'cardList'},//明信片订单
                {path: '/postcard', component: postcard, name: 'postcard'},//明信片 添加
                {path: '/sms', component: sms, name: 'sms'},//明信片 添加
                {path: '/protocol', component: protocol, name: 'protocol'},//明信片 协议
                {//店铺管理
                    path: '/shopManage',
                    component: shopManage,
                    name: 'shopManage',
                },
                {//统计
                    path: '/statistics',
                    component: statistics,
                    name: 'statistics',
                },
                {//店铺添加编辑
                    path: '/shopAdd',
                    component: shopAdd,
                    name: 'shopAdd',
                },
                {//员工
                    path: '/staffList',
                    component: staffList,
                    name: 'staffList',
                },
                {//券 管理
                    path: '/couponList',
                    component: couponList,
                    name: 'couponList',
                },
                {//券包
                    path: '/coupons',
                    component: coupons,
                    name: 'coupons',
                },
                {//优惠券设置页面
                    path: '/couponSetting',
                    component: couponSetting,
                    name: 'couponSetting',
                },
                {//优惠券
                    path: '/coupon',
                    component: coupon,
                    name: 'coupon',
                },
                //修改套餐列表
                {
                    path: '/EditList',
                    component: EditList,
                    name: 'EditList',
                },
                //景区订单详情
                {
                    path: '/OrderDetails',
                    component: OrderDetails,
                    name: 'OrderDetails',
                },
                //景区套餐详情
                {
                    path: '/PackageOrders',
                    component: PackageOrders,
                    name: 'PackageOrders',
                },
                //景区活动列表
                {
                    path: '/ActivityList',
                    component: ActivityList,
                    name: 'ActivityList',
                },
                //用户列表
                {
                    path: '/MemberList',
                    component: MemberList,
                    name: 'MemberList',
                },
            ]
        },
        //网页页头
        {
            path: '/pageHeader',
            component: pageHeader,
            meta: {
                requiresAuth: true
            },
        },
        //网页登录
        {
            path: '/',
            component: pageLogin,

        },
        //网页注册
        {
            path: '/pageLogon',
            component: pageLogon,
            meta: {
                requiresAuth: true
            },
        },
        //网页菜单
        {
            path: '/pageMenu',
            component: pageMenu,
            meta: {
                requiresAuth: true
            },
        },

    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js